import {RootState} from "../reducer";
import { IModal } from "src/type/modal";

export const ModalAction = Object.freeze({ 
    INIT_MODAL: 'INIT_MODAL',
    OPEN_MODAL: 'OPEN_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL',
    RESET_MODAL: 'RESET_MODAL',
    
    initModal: (modal: IModal) => (dispatch, getState: () => RootState) => {
        return dispatch({
            type: ModalAction.INIT_MODAL,
            modal
        })
    },
    openModal: (modal?: IModal) => (dispatch) => dispatch({type: ModalAction.OPEN_MODAL, modal}),
    closeModal: () => (dispatch) => dispatch({type: ModalAction.CLOSE_MODAL}),
    resetModal: () => (dispatch) => dispatch({type: ModalAction.RESET_MODAL}),
})





// WEBPACK FOOTER //
// ./src/core/redux/action/modalActions.ts